export default {
  id: 'default',
  name: 'Default',
  versions: {
    'default': {
      version: '1.6.0',
      configuration: {
        format: 'BIDS',
        base: ''
      }
    }
  }
}
